import { apiClient } from "@vv/api";
import type { AppNotification } from "../domain/notification.types";

export const notificationsApi = {
  list: () => apiClient.get<AppNotification[]>("/notifications"),

  unreadCount: () => apiClient.get<{ count: number }>("/notifications/unread-count"),

  markRead: (id: string) => apiClient.post<AppNotification>(`/notifications/${id}/read`),

  markAllRead: () => apiClient.post<{ success: true }>("/notifications/read-all"),
};
